const $ = window.jQuery;

/**
 * Enables 'CookieConsent' plugin specific scripting
 */
const CookieConsent = {

    $container: false,
    $banner: false,
    version: 1,

    /**
     * Initialise functionality
     */
    init()
    {

        const vm = this;

        vm.initInstances();

        // Skip if required elements aren't present
        if (!vm.$container.length || !vm.$banner.length) {
            return;
        }

        vm.maybeShowBanner();

    },

    /**
     * Initialise buttons for consent
     */
    initInstances()
    {

        const vm = this;

        vm.version = scriptVars.plugins.cookieConsent.version || 1;

        // Find and assign container
        const $container = $('.mwb-plugin-cookie-consent-container');
        if (!$container.length) {
            return;
        }
        vm.$container = $container;

        // Find and assign banner
        const $banner = $container.find('.mwb-plugin-cookie-consent-banner');
        if (!$banner.length) {
            return;
        }
        vm.$banner = $banner;

        // Setup listeners for accept/decline buttons
        vm.$container.find('[data-cookie-consent-accept]').
        on('click', () => vm.acceptConsent());
        vm.$container.find('[data-cookie-consent-decline]').
        on('click', () => vm.declineConsent());

    },

    /**
     * Handle user consenting
     */
    acceptConsent()
    {

        const vm = this;

        vm.hideBanner();

        // Store accepted policy version (if different)
        const acceptedVersion = vm.getAcceptedVersion();
        if (vm.version !== acceptedVersion) {
            vm.storeAcceptedVersion(vm.version);
        }

        // Trigger JS event
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'cookie_consent_given',
        });

    },

    /**
     * Handle user declining
     */
    declineConsent()
    {

        const vm = this;

        vm.hideBanner();

        // Store declined policy version (if different)
        const declinedVersion = vm.storeDeclinedVersion();
        if (vm.version !== declinedVersion) {
            vm.storeDeclinedVersion(vm.version);
        }

    },

    /**
     * Maybe show banner based on previous accept/decline and current consent
     * version
     */
    maybeShowBanner()
    {

        const vm = this;

        // Check if declined version is still valid
        const declinedVersion = vm.getDeclinedVersion();
        if (declinedVersion && declinedVersion === vm.version) {
            return;
        }

        // Check if accepted version is still valid
        const acceptedVersion = vm.getAcceptedVersion();
        if (acceptedVersion && acceptedVersion === vm.version) {
            this.acceptConsent();
            return;
        }

        // User has either never accepted or declined, or the consent version has
        // changed since
        vm.showBanner();

    },

    /**
     * Show banner
     */
    showBanner()
    {
        this.$banner.removeClass('opacity-0 pointer-events-none');
        this.$banner.addClass('pointer-events-auto');
    },

    /**
     * Hide banner
     */
    hideBanner()
    {
        this.$banner.removeClass('pointer-events-auto');
        this.$banner.addClass('opacity-0 pointer-events-none');
    },

    /**
     * Whether device has local storage support
     * @returns bool
     */
    hasLocalStorageSupport()
    {
        if (typeof (Storage) === 'undefined') {
            console.error(
                'Cookie consent choice could not be saved, localStorage API not available');
            return false;
        }
        return true;
    },

    /**
     * Get version that user has previously accepted
     * @returns int (0 if never accepted)
     */
    getAcceptedVersion()
    {
        return parseInt(
            localStorage.getItem('cookie-consent-accepted-version') || 0);
    },

    /**
     * Store version that user has accepted
     */
    storeAcceptedVersion()
    {
        return localStorage.setItem('cookie-consent-accepted-version', this.version);
    },

    /**
     * Get version that user has previously declined
     * @returns int (0 if never accepted)
     */
    getDeclinedVersion()
    {
        return parseInt(
            localStorage.getItem('cookie-consent-declined-version') || 0);
    },

    /**
     * Store version that user has declined
     */
    storeDeclinedVersion()
    {
        return localStorage.setItem('cookie-consent-declined-version', this.version);
    },

};

export default CookieConsent;